import React, { ReactNode } from "react";
import { ShareButtonsContainer, ShareContainer } from "./share-page.styles";
import { Icon, IconButton, useMediaQuery } from "@mui/material";
import RedditIcon from '@mui/icons-material/Reddit';
import XIcon from '@mui/icons-material/X';
import { useTranslation } from "react-i18next";
import { screenBreackpoints } from "../../theme";
import { ShareType } from "./share-page.types";

interface Props {
  shareTitle: string;
  shareChild: ReactNode;
}

export const SharePage: React.FC<Props> = ({
  shareTitle,
  shareChild
}: Props) => {
  const isMobile = useMediaQuery(`(max-width:${screenBreackpoints.mobile})`);
  const { t } = useTranslation();

  const handleShare = (shareType: ShareType) => {
    const url = window.location.origin + window.location.pathname + window.location.search;

    switch (shareType) {
      case ShareType.REDDIT:
        const redditShareUrl = `https://www.reddit.com/submit?url=${encodeURIComponent(url)}&title=${encodeURIComponent(shareTitle)}&type=LINK`;
        window.open(redditShareUrl, '_blank');
        break;

      case ShareType.X:
        const twitterShareUrl = `https://x.com/share?url=${encodeURIComponent(url)}&text=${encodeURIComponent(shareTitle + " @topbrawl_")}`;
        window.open(twitterShareUrl, '_blank');
        break;

      default:
        if (navigator.share) {
          navigator.share({ title: shareTitle, url: url });
        } else {
          navigator.clipboard.writeText(url)
            .then(() => {
              alert(t("COMPONENTS.SHARE.CLIPBOARD"));
            })
            .catch((error) => {
              console.error('Error copying to clipboard', error);
            });
        }
        break;
    }
  };

  return (
    <ShareContainer isMobile={isMobile}>
      {shareChild}
      <ShareButtonsContainer>
        <IconButton size="small" aria-label={t("COMPONENTS.SHARE.SHARE") + " Reddit"}
          onClick={() => handleShare(ShareType.REDDIT)}>
          <RedditIcon />
        </IconButton>
        <IconButton size="small" aria-label={t("COMPONENTS.SHARE.SHARE") + " X"}
          onClick={() => handleShare(ShareType.X)}>
          <XIcon />
        </IconButton>
        <IconButton size="small" aria-label={t("COMPONENTS.SHARE.SHARE")}
          onClick={() => handleShare(ShareType.DEFAULT)}>
          <Icon baseClassName="material-symbols-outlined">share</Icon>
        </IconButton>
      </ShareButtonsContainer>
    </ShareContainer>
  );
}
